import { render, staticRenderFns } from "./CmgRewardRedemptionSuccessModal.vue?vue&type=template&id=fa5bade0&scoped=true&lang=pug"
import script from "./cmg-reward-redemption-success-modal.ts?vue&type=script&lang=ts&external"
export * from "./cmg-reward-redemption-success-modal.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgRewardRedemptionSuccessModal.vue?vue&type=style&index=0&id=fa5bade0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa5bade0",
  null
  
)

export default component.exports